function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTowerBasePlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1-0-5-7",
    width: 19.84375,
    height: 19.84375,
    x: 0,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d4ae26",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2-5-2-1",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47919
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.27183354,
      strokeOpacity: 1
    },
    id: "rect8773-0-56-9-4-2",
    width: 25.135418,
    height: 1.8520833,
    x: -208.5466,
    y: 209.08467,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    id: "g14396-3",
    transform: "matrix(1.0501298,0,0,1.0500505,-34.393334,481.93596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14147-6",
    d: "m 40.573729,-192.0568 c -0.78814,-0.0162 -1.72263,0.49161 -2.907114,1.59811 -1.722885,1.60945 -2.763105,3.54068 -1.982931,4.6234 0.780175,1.08273 3.283272,0.64376 3.283272,-0.58528 0,-1.22903 0.780073,-1.90189 2.015349,-2.77978 1.235276,-0.87788 1.56932,-1.82281 0.585334,-2.51667 -0.307496,-0.21683 -0.635664,-0.33243 -0.99391,-0.33978 z m -0.115523,0.7627 c 0.173224,-0.008 0.32781,0.0305 0.467495,0.11348 0.558744,0.33175 0.06475,0.82463 -0.768266,1.44386 -0.833019,0.61924 -2.061315,1.75767 -2.11878,2.65564 -0.05747,0.89797 -1.186661,1.20322 -1.564577,0.53433 -0.377917,-0.66889 0.525426,-2.23161 1.811575,-3.40653 0.964612,-0.88119 1.652882,-1.31764 2.172553,-1.34078 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.12498554px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-7",
    d: "m 37.673624,-191.47592 c -0.142332,0.10297 -0.264693,0.38534 -0.181922,0.51518 l 0.374654,0.58774 0.734032,-0.49 -0.374654,-0.58774 c -0.114699,-0.14748 -0.409778,-0.12815 -0.55211,-0.0252 z",
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-6-2",
    d: "m 35.854924,-185.13461 0.498431,-0.52976 -0.599942,-0.63062 -0.498432,0.52975 c -0.110114,0.11701 -0.100201,0.39757 0.06129,0.53652 0.161491,0.13894 0.353388,0.24685 0.538654,0.0941 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-62-4",
    d: "m 35.164762,-187.2208 0.740538,0.1216 0.209979,-0.8706 -0.740538,-0.12161 c -0.163595,-0.0269 -0.465791,0.12385 -0.480443,0.33284 -0.01465,0.20899 0.107333,0.50139 0.270464,0.53777 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-06-5",
    d: "m 39.745545,-192.60849 c -0.181716,0.0448 -0.394005,0.25811 -0.352008,0.40295 l 0.190112,0.65566 0.844561,-0.2583 -0.190112,-0.65566 c -0.042,-0.14484 -0.310837,-0.18944 -0.492553,-0.14465 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-3-8",
    d: "m 36.001942,-189.8331 c -0.14884,0.16917 -0.162359,0.48325 -0.03869,0.58333 l 0.559829,0.453 0.594636,-0.6644 -0.559829,-0.453 c -0.188699,-0.12742 -0.407102,-0.0881 -0.555943,0.0811 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-0-6-9",
    d: "m 42.161632,-192.25299 c -0.129111,-0.14788 -0.535649,-0.0448 -0.647895,0.0657 l -0.508071,0.5 0.596557,0.67795 0.508071,-0.5 c 0.259199,-0.23325 0.18045,-0.59573 0.05134,-0.74361 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-0-11-7",
    d: "m 42.37279,-189.67995 c 0.110815,-0.16134 0.108155,-0.42569 -0.02865,-0.51081 l -0.619241,-0.38528 -0.518895,0.70183 0.619241,0.38529 c 0.219343,0.038 0.43673,-0.0297 0.547545,-0.19103 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-0-7-8",
    d: "m 40.642482,-188.12807 c 0.130434,-0.12106 0.206754,-0.42697 0.08956,-0.53318 l -0.530462,-0.48078 -0.627784,0.59972 0.530462,0.48078 c 0.192371,0.0714 0.407786,0.0545 0.53822,-0.0665 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-0-0-9",
    d: "m 39.320574,-187.10046 -0.752503,-0.0176 -0.04833,0.87815 0.752504,0.0176 c 0.166241,0.004 0.458733,-0.11147 0.467387,-0.42012 0.0087,-0.30864 -0.203782,-0.45066 -0.419058,-0.45803 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14164-0-70-4",
    d: "m 37.775866,-184.56428 c 0.290586,-0.0306 0.46166,-0.35521 0.449376,-0.50518 l -0.0556,-0.67883 -0.933224,0.0976 0.0556,0.67883 c 0.01228,0.14996 0.193269,0.43811 0.483849,0.40756 z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19975863,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.34310433
    },
    id: "path7239-9",
    d: "m 9.9480612,294.15076 c 0.3078198,-0.13947 0.6184558,-0.26569 0.9085388,-0.43124 0.229013,-0.089 0.406649,-0.25779 0.617162,-0.37373 0.154253,-0.10014 0.287526,-0.22826 0.444692,-0.32709 0.125195,-0.14475 0.293746,-0.24673 0.416927,-0.39408 0.144438,-0.11402 0.247313,-0.26601 0.378031,-0.3939 0.194515,-0.2779 0.429337,-0.53739 0.568713,-0.84877 0.08541,-0.2243 0.201951,-0.43704 0.262917,-0.66977 0.101622,-0.26861 0.213359,-0.5335 0.31064,-0.80357 0.113669,-0.26588 0.222245,-0.53179 0.348365,-0.79202 0.183501,-0.43719 0.429843,-0.85173 0.729584,-1.22141 0.179382,-0.24536 0.394644,-0.45398 0.632624,-0.64476 0.38397,-0.23505 -0.272052,-0.0869 -0.430621,-0.0128 -0.345948,0.087 -0.685756,0.17922 -1.020213,0.30188 -0.353688,0.19892 -0.72524,0.34928 -1.036086,0.6078 -0.205503,0.18598 -0.428976,0.35554 -0.574027,0.59644 -0.218889,0.28941 -0.369598,0.62677 -0.523339,0.95247 -0.09402,0.26958 -0.197137,0.53441 -0.256525,0.81254 -0.041,0.11299 -0.03923,0.23357 -0.08615,0.34481 -0.0076,0.19981 -0.04682,0.39049 -0.07097,0.58445 -0.03465,0.27075 -0.03717,0.54206 -0.0819,0.80981 7.41e-4,0.17587 -0.0378,0.34726 -0.08368,0.51749 -0.06202,0.26032 -0.256107,0.46556 -0.461033,0.62617 -0.190033,0.13227 -0.372124,0.28913 -0.600966,0.35861 -0.161548,0.0412 -0.308588,0.12862 -0.4803688,0.12572 -0.1838539,0.059 -0.6988141,0.0196 -0.3482779,0.28131 0.1239128,0.12927 0.2953419,0.0314 0.4359809,-0.006 z m 2.9098928,-0.51254 c 0.556857,-0.14929 1.145279,-0.25571 1.616397,-0.60685 0.632898,-0.39487 1.094188,-1.00723 1.377738,-1.68057 0.519599,-1.13756 0.575591,-2.40873 0.984147,-3.58135 0.177727,-0.34171 0.354312,-0.69361 0.609442,-0.98628 0.191461,-0.095 0.217808,-0.36624 -0.03548,-0.15641 -0.73562,0.47626 -1.52228,0.92737 -2.045862,1.6444 -0.411092,0.5469 -0.669365,1.18875 -0.930002,1.81392 -0.332341,0.7822 -0.560338,1.61813 -1.057922,2.3217 -0.314919,0.41743 -0.631888,0.8606 -1.070758,1.16003 -0.316199,0.20288 0.0797,0.2393 0.25172,0.13596 0.09853,-0.03 0.198836,-0.0484 0.300593,-0.0645 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTowerBasePlot);
export default __webpack_public_path__ + "static/media/icon-tower-base-plot.f5582ca4f97c813db93ac432f68d9f1f.svg";
export { ForwardRef as ReactComponent };